export const runHaptic = (type: 'impactLight') => {};
